import LangEnum from '../../../../../../../lang/LangEnum';
import { ReturnTypeOfUseDateRangeFilter } from '../../../../../../Crud/filters/sharedBetweenFilters/types';
import DateRangeFilterV2 from '../../../DateRangeFilterV2';
import { DateRangeValue, DateShortcut, DateShortcutValue } from '../../../dateRangeFilter.types';

interface DateRangeFilterProps {
  label: LangEnum;
  filterIndex: number;
  dateRangeFilter: ReturnTypeOfUseDateRangeFilter;
  excludedShortcuts?: DateShortcut[];
}

export const DateRangeFilterToFilterV3 = ({
  label,
  dateRangeFilter,
  filterIndex,
  excludedShortcuts,
}: DateRangeFilterProps) => (
  <DateRangeFilterV2
    label={label}
    minimized
    filterIndex={filterIndex}
    excludedShortcuts={excludedShortcuts}
    onChange={(value) => {
      const { finalDate, initialDate } = value as DateRangeValue;
      const { shortcut, shortcutStep } = value as DateShortcutValue;
      dateRangeFilter.setInitialDate(initialDate);
      dateRangeFilter.setFinalDate(finalDate);
      dateRangeFilter.setShortcut(shortcut);
      dateRangeFilter.setShortcutStep(shortcutStep);
    }}
    value={{
      finalDate: dateRangeFilter.finalDate,
      initialDate: dateRangeFilter.initialDate,
      shortcut: dateRangeFilter.shortcut,
      shortcutStep: dateRangeFilter.shortcutStep || 0,
    }}
  />
);
